import createReduxPromiseActionType from "utils/create_redux_promise_action_type";

const actionTypes = {};
createReduxPromiseActionType(actionTypes, "REPORTS_FETCH");
createReduxPromiseActionType(actionTypes, "REPORTS_CLEAR");
createReduxPromiseActionType(actionTypes, "DOCUMENT_REPORT_FETCH");

export default actionTypes;
